module.exports = __webpack_public_path__ + "img/las-reservas6.04c0797b.png";